var chunkMapping = {
	"0": [
		4931
	],
	"76": [
		5049
	],
	"151": [
		5124
	],
	"152": [
		5125
	],
	"155": [
		5128
	],
	"156": [
		5129
	],
	"157": [
		5130
	],
	"158": [
		5131
	],
	"159": [
		5132
	],
	"160": [
		5133
	],
	"161": [
		5134
	],
	"162": [
		5135
	],
	"163": [
		5136
	],
	"164": [
		5137
	],
	"165": [
		5138
	],
	"166": [
		5139
	],
	"167": [
		5140
	],
	"168": [
		5141
	],
	"169": [
		5142
	],
	"170": [
		5143
	],
	"171": [
		5144
	]
};
var idToExternalAndNameMapping = {
	"4931": [
		"default",
		"./Containers",
		3803
	],
	"5049": [
		"default",
		"./OrderlessInvoices",
		3803
	],
	"5124": [
		"default",
		"./AsyncEventTracker",
		3803
	],
	"5125": [
		"default",
		"./HostWrapper",
		3803
	],
	"5128": [
		"default",
		"./CheckoutV3",
		3803
	],
	"5129": [
		"default",
		"./CheckoutConfirmation",
		3803
	],
	"5130": [
		"default",
		"./ContactCreditCards",
		3803
	],
	"5131": [
		"default",
		"./AuditDialog",
		3803
	],
	"5132": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3803
	],
	"5133": [
		"default",
		"./InvoiceDialog",
		3803
	],
	"5134": [
		"default",
		"./PaymentDueModal",
		3803
	],
	"5135": [
		"default",
		"./PaymentModal",
		3803
	],
	"5136": [
		"default",
		"./PaymentHistory",
		3803
	],
	"5137": [
		"default",
		"./PaymentConfigurations",
		3803
	],
	"5138": [
		"default",
		"./PaymentPreferences",
		3803
	],
	"5139": [
		"default",
		"./ManagePaymentProcessing",
		3803
	],
	"5140": [
		"default",
		"./MobilePaymentsWrapper",
		3803
	],
	"5141": [
		"default",
		"./Challenge",
		3803
	],
	"5142": [
		"default",
		"./ManagePaymentMethods",
		3803
	],
	"5143": [
		"default",
		"./LightspeedReports",
		3803
	],
	"5144": [
		"default",
		"./ShippingPromotionsListContainer",
		3803
	]
};
var idToRemoteMap = {
	"4931": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5049": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5124": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5125": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5128": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5129": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3803
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}